import React from "react";
import { routingBadgeStyle, syncGateStyle, ROUTING_LABELS, SYNC_GATE_LABELS } from "@/lib/aiProvenance";

export function RoutingClassBadge({ value, className = "", testid }) {
  const s = routingBadgeStyle(value);
  const label = ROUTING_LABELS[(value || "UNKNOWN").toUpperCase()] || value || "UNKNOWN";
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-[10.5px] uppercase tracking-[0.14em] font-medium border ${className}`}
      style={{ background: s.background, color: s.color, borderColor: s.border }}
      data-testid={testid || `routing-badge-${(value||"unknown").toLowerCase()}`}
    >
      {label}
    </span>
  );
}

export function SyncGateBadge({ value, className = "", testid }) {
  const s = syncGateStyle(value);
  const label = SYNC_GATE_LABELS[(value || "BLOCKED").toUpperCase()] || value || "BLOCKED";
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-[10.5px] uppercase tracking-[0.14em] font-medium border ${className}`}
      style={{ background: s.background, color: s.color, borderColor: s.border }}
      data-testid={testid || `sync-gate-badge-${(value||"blocked").toLowerCase()}`}
    >
      {label}
    </span>
  );
}
